
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import {
    ADD_COMMAND
} from './map';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const CATEGORY_OPERATION_ACTION_TYPE = createActionTypes('category/OPERATION');
export const CATEGORY_ADDSET_ACTION_TYPE = 'category/ADDSET';
export const CATEGORY_GET_ACTION_TYPE = 'category/GET';
export const CATEGORY_REMOVE_ACTION_TYPE = 'category/REMOVE';
export const CATEGORY_SET_ACTION_TYPE = 'category/SET';
export const CATEGORY_SET_ACTUAL_CATEGORY_ACTION_TYPE = 'category/SET_ACTUAL_CATEGORY';
export const CATEGORY_CREATE_ACTION_TYPE = 'category/CREATE';
export const CATEGORY_CREATE_ITEM_ACTION_TYPE = 'category/CREATE_ITEM';
export const CATEGORY_DELETE_ACTION_TYPE = 'category/DELETE';
export const CATEGORY_DELETE_ITEM_ACTION_TYPE = 'category/DELETE_ITEM';
export const CATEGORY_GENERATE_CLUSTERS_ACTION_TYPE = 'category/GENERATE_CLUSTERS';
export const CATEGORY_EDIT_ITEM_ACTION_TYPE = 'category/EDIT_ITEM';
export const CATEGORY_IMPORT_DATA_ACTION_TYPE = 'category/IMPORT_DATA';

export default function getActions(dispatch) {
    return {
        categoryAddSet: (token, projectId, listName, categoryName, itemColor, itemTitle) => dispatch({
            type: CATEGORY_ADDSET_ACTION_TYPE, operation: 'ADDSET',
            token, projectId, listName, categoryName, itemColor, itemTitle
        }),
        categoryGet: (token, projectId) => dispatch({
            type: CATEGORY_GET_ACTION_TYPE, token, projectId
        }),
        categoryRemove: (token, projectId, listName, categoryName) => dispatch({
            type: CATEGORY_REMOVE_ACTION_TYPE, operation: 'REMOVE',
            token, projectId, listName, categoryName
        }),
        categorySet: (token, projectId, listName, categoryName, itemName) => dispatch({
            type: CATEGORY_SET_ACTION_TYPE, operation: 'SET',
            token, projectId, listName, categoryName, itemName
        }),
        createCategory: (token, projectId, title) => dispatch({
            type: CATEGORY_CREATE_ACTION_TYPE, operation: 'CREATE', token, projectId, title
        }),
        createCategoryItem: (token, projectId, categoryName, title, color) => dispatch({
            type: CATEGORY_CREATE_ITEM_ACTION_TYPE, operation: 'CREATE_ITEM',
            token, projectId, categoryName, title, color
        }),
        deleteCategory: (token, projectId, name) => dispatch({
            type: CATEGORY_DELETE_ACTION_TYPE, operation: 'DELETE', token, projectId, name
        }),
        deleteCategoryItem: (token, projectId, categoryName, name) => dispatch({
            type: CATEGORY_DELETE_ITEM_ACTION_TYPE, operation: 'DELETE_ITEM',
            token, projectId, categoryName, name
        }),
        editCategoryItem: (token, projectId, categoryName, name, title, color) => dispatch({
            type: CATEGORY_EDIT_ITEM_ACTION_TYPE, operation: 'EDIT_ITEM',
            token, projectId, categoryName, name, title, color
        }),
        generateClusters: (token, projectId, listName, categoryName) => dispatch({
            type: CATEGORY_GENERATE_CLUSTERS_ACTION_TYPE, operation: 'GENERATE_CLUSTERS',
            token, projectId, listName, categoryName
        }),
        importCategoryData: (token, projectId, listName, categoryName, categoryItems, parc, keepCategoryItemNames, importMode) => dispatch({
            type: CATEGORY_IMPORT_DATA_ACTION_TYPE,
            token, projectId, listName, categoryName,
            categoryItems, parc, keepCategoryItemNames, importMode, operation: 'IMPORT_DATA'
        }),
        setActualCategory: (category) => dispatch({
            type: CATEGORY_SET_ACTUAL_CATEGORY_ACTION_TYPE, category
        })
    };
}

function categoryExec(serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'categoryExec',
            token: action.token,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function categoryGet(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'categoryGet',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workCategoryOperation(options, func, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.DEFAULT});
        const data = yield call(func, options.serverApi, action);
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
        yield put({type: ADD_COMMAND, name: 'REDRAW', params: {layers: ['category_parcela', 'category_cluster']}});
    } catch (error) {
        yield call(setOperationError, error, CATEGORY_OPERATION_ACTION_TYPE);
    }
}

export function* watchCategoryAddSet(options) {
    yield takeEvery(
        CATEGORY_ADDSET_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Přidání parcel do nové položky kategorie'
    );
}

export function* watchCategoryCreate(options) {
    yield takeEvery(
        CATEGORY_CREATE_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Vytvoření nové kategorie'
    );
}

export function* watchCategoryCreateItem(options) {
    yield takeEvery(
        CATEGORY_CREATE_ITEM_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Vytvoření nové položky kategorie'
    );
}

export function* watchCategoryDelete(options) {
    yield takeEvery(
        CATEGORY_DELETE_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Smazání kategorie'
    );
}

export function* watchCategoryDeleteItem(options) {
    yield takeEvery(
        CATEGORY_DELETE_ITEM_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Smazání položky kategorie'
    );
}

export function* watchCategoryEditItem(options) {
    yield takeEvery(
        CATEGORY_EDIT_ITEM_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Úprava položky kategorie'
    );
}

export function* watchCategoryGenerateClusters(options) {
    yield takeEvery(
        CATEGORY_GENERATE_CLUSTERS_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Generování souvislosti parcel kategorie'
    );
}

function* workCategoryGet(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(categoryGet, options.serverApi, action);
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, CATEGORY_OPERATION_ACTION_TYPE);
    }
}

export function* watchCategoryGet(options) {
    yield takeEvery(CATEGORY_GET_ACTION_TYPE, workCategoryGet, options);
}

export function* watchCategoryImportData(options) {
    yield takeEvery(
        CATEGORY_IMPORT_DATA_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Import dat do aktuální kategorie'
    );
}

export function* watchCategoryRemove(options) {
    yield takeEvery(
        CATEGORY_REMOVE_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Odstranění parcel z položky kategorie'
    );
}

export function* watchCategorySet(options) {
    yield takeEvery(
        CATEGORY_SET_ACTION_TYPE, workCategoryOperation, options,
        categoryExec, 'Přidání parcel do položky kategorie'
    );
}
